export default __webpack_public_path__ + "static/media/MISTRZ_SILY.c8ea31f9.png";